import React from 'react';
import { WorldMap } from '../components/WorldMap';

export const GameStartPage: React.FC = () => {
  return <WorldMap />;
};

